import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import LateralProgressBar from "../../components/lateralProgressBar/lateralProgressBar";

const MedicalPaLoaderScreen = () => {
  const [progress, setProgress] = useState(0);
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => prev + 10);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (progress === 100) {
      navigate(`/worklists/submission-status/${id}`);
    }
  }, [progress, navigate]);

  return (
    <div className="medical-pharma-pa-form__container flex h-full flex-col items-center justify-center bg-[#F7F9FA] px-[0.9375rem] py-[0.625rem]">
      <>
        <div className="medical-pharma-pa-form__body flex w-1/2 flex-1 flex-col items-center justify-center overflow-hidden rounded bg-white p-4 pb-0">
          <LateralProgressBar progress={progress} />
          <div className="progress-bar__details mt-10 flex flex-col items-center justify-center gap-2">
            <div className="progress-bar__header text-h8 font-semibold text-primaryGray-2">
              Submitting Form
            </div>
            <div className="progress-bar__description text-body text-primaryGray-7">
              Submitting the form on NCH portal
            </div>
          </div>
        </div>
      </>
    </div>
  );
};

export default MedicalPaLoaderScreen;
